import { useEffect, useMemo } from 'react';

import { ChainTypeTab } from 'modules/chains/components/ChainTypeTab';
import { SecondaryTabs } from 'modules/common/components/SecondaryTabs';
import { Tab, useTabs } from 'modules/common/hooks/useTabs';

import {
  ChainCallProtocol,
  useChainSelectors,
} from '../ChainSelectorsProvider';

interface ChainCallProtocolTabsProps {
  className?: string;
  classNameTab?: string;
  classNameTabsInner?: string;
  classNameTabsWrapper?: string;
}

export const ChainCallProtocolTabs = ({
  className,
  classNameTab,
  classNameTabsInner,
  classNameTabsWrapper,
}: ChainCallProtocolTabsProps) => {
  const { group } = useChainSelectors();

  const hasGRPCChains = Boolean(
    group?.chains.some(chain => chain.hasGRPCFeature) &&
      group.chains.length > 1,
  );

  const hasGRPCURLs = Boolean(
    group?.urls.some(url => url.grpc) && group.urls.length > 1,
  );

  const { chainCallProtocol, setChainCallProtocol } = useChainSelectors();

  const tabs = useMemo<Tab<ChainCallProtocol>[]>(
    () => [
      {
        id: 'rpc/rest',
        title: (isSelected: boolean) => {
          return <ChainTypeTab isSelected={isSelected} label="RPC/REST" />;
        },
        onSelect: () => setChainCallProtocol('rpc/rest'),
      },
      {
        id: 'grpc',
        title: (isSelected: boolean) => {
          return <ChainTypeTab isSelected={isSelected} label="gRPC" />;
        },
        onSelect: () => setChainCallProtocol('grpc'),
      },
    ],
    [setChainCallProtocol],
  );

  const [chainProtocolTabs, chainProtocolTab, selectTab] = useTabs({
    tabs,
    initialTabID: chainCallProtocol,
  });

  useEffect(() => {
    selectTab(chainCallProtocol);

    // only chainCallProtocol should be tracked
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainCallProtocol]);

  return (
    <SecondaryTabs
      className={className}
      classNameTab={classNameTab}
      classNameTabsInner={classNameTabsInner}
      classNameTabsWrapper={classNameTabsWrapper}
      selectedTab={chainProtocolTab}
      tabs={chainProtocolTabs}
      visible={hasGRPCChains && hasGRPCURLs}
    />
  );
};
